import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose, find, defaultTo, path } from 'ramda';
import Select from 'react-select';
import moment from 'moment';

import { apiRequestExtension } from '../../../../api/extension';
import { handleErrorBase, handleSuccessBase } from '../../../../util/forms';
import { routes } from '../../../../routes';
import userActions from '../../../../redux/user';
import { apiGetExtensionDiscount } from '../../../../api/discount';

import Card from '../../../../components/Card';
import DiscountForm from '../../../../components/DiscountForm';
import StripeCheckout from '../../../../components/StripeCheckout';
import EditField from '../../../../components/Forms/EditField';
import { isNilOrEmpty } from '../../../../util/redux';
import magic from '../../../../util/magic';

const mapStore = ({ user }) => ({
  extensions: user.extensions,
  user,
});

const mapDispatch = {
  ...userActions,
};

class Request extends Component {
  static propTypes = {
    extensions: PropTypes.array,
    updateUserExtensions: PropTypes.func,
  };

  state = {
    extension: '',
    essay: '',
    completedHours: '',
    signature: '',
    price: 200,
    discount: {},
  };

  getInput = (possibleExtensions) => {
    const input = this.state;
    const extension = possibleExtensions[input.extension];

    if (isNilOrEmpty(extension.deadline)) {
      input.userCertificationId = extension.id;
    } else {
      input.registrationId = extension.id;
    }
    return input;
  };

  getExtensionDeadline = (possibleExtensions) => {
    const { extension } = this.state;
    const selectedExtension = defaultTo({}, possibleExtensions[extension]);
    const reportingPeriod = defaultTo({}, selectedExtension.reportingPeriod);
    const deadline = defaultTo(path(['deadline'], selectedExtension), reportingPeriod.end);
    return deadline;
  };

  getExtensionName = (extension) => {
    if (isNilOrEmpty(extension.deadline)) {
      return extension.name;
    } else if (isNilOrEmpty(extension.trainingId)) {
      return extension.certification.name;
    }
    return extension.training.name;
  };

  hasApprovedExtension = (id) => {
    return compose(
      defaultTo(false),
      path(['approved']),
      find((e) => e.category.id == id && e.approved == true),
    )(this.props.extensions);
  };

  render() {
    const { extensions, history, updateUserExtensions, user } = this.props;
    const { extension, completedHours, essay, signature, price, discount } = this.state;
    const registrations = user.latestRegistrations.filter(
      (registration) =>
        !isNilOrEmpty(path(['deadline'], registration)) &&
        registration.status != magic.complete &&
        path(['training', 'allowExtensions'], registration) !== false &&
        !this.hasApprovedExtension(registration.id),
    );
    const filteredCertifications = user.userCertifications.filter(
      (certification) =>
        (certification.status == magic.certificateGoodStanding ||
          certification.status == magic.certificateLapsedCEUs) &&
        !this.hasApprovedExtension(certification.id),
    );
    const possibleExtensions = [...filteredCertifications, ...registrations];
    const deadline = this.getExtensionDeadline(possibleExtensions);

    return (
      <Card className="container">
        <Card.Header>File an extension</Card.Header>
        <Card.Body>
          <p>
            A 6-month extension is available with payment of the <strong>${price} extension fee</strong>. If you wish to
            obtain an extension, please complete all fields of this form. Your signature at the bottom indicates your
            commitment to fulfilling this new plan for successful completion. Sage Financial Solutions will notify you about the status of
            your extension request within 2-3 business days of receipt. If approved, an extension of six months from
            your original deadline will be granted. All program requirements must be met within the 6 month extension
            period or re-enrollment in the program will be necessary. No further extensions will be considered or
            granted.
          </p>
          <div className="offset-md-1">
            <EditField
              as={Select}
              bare
              simpleValue
              name="extension"
              label="Program"
              onChange={(value) => this.setState({ extension: value })}
              options={possibleExtensions.map((extension, index) => ({
                value: index,
                label: this.getExtensionName(extension),
              }))}
              value={extension}
            />
            {deadline && (
              <Fragment>
                <div className="form-group row">
                  <label className="col-form-label col-md-3">Existing Deadline</label>
                  <div className="col-md-7 d-flex align-items-center">{moment(deadline).format('MM/DD/YYYY')}</div>
                </div>
                <div className="form-group row">
                  <label className="col-form-label col-md-3">Deadline afer extension</label>
                  <div className="col-md-7 d-flex align-items-center">
                    {moment(deadline).add(6, 'M').format('MM/DD/YYYY')}
                  </div>
                </div>
              </Fragment>
            )}
            <EditField
              name="completedHours"
              label="Completed Hours (AFC only)"
              required
              onChange={({ target }) => this.setState({ completedHours: target.value })}
              value={completedHours}
            />
            <EditField
              as="textarea"
              name="essay"
              label="Reason"
              required
              onChange={({ target }) =>
                this.setState({
                  essay: target.value,
                })
              }
              value={essay}
            />
            <EditField
              name="signature"
              label="Signature"
              required
              onChange={({ target }) =>
                this.setState({
                  signature: target.value,
                })
              }
              value={signature}
            />

            <DiscountForm
              discount={discount}
              checkDiscount={(discountCode) => apiGetExtensionDiscount({ discountCode })}
              update={(data) => {
                this.setState({ price: data.payment / 100, discount: defaultTo({}, data.discount) });
              }}
            />

            <div className="text-right mt-5">
              <StripeCheckout
                name="Sage Financial Solutions"
                description="Extension Payment"
                amount={price}
                pay={(token, overrides = {}) =>
                  apiRequestExtension({
                    ...this.getInput(possibleExtensions),
                    token,
                    discountCode: discount.code,
                    ...overrides,
                  })
                    .then(({ data }) => updateUserExtensions([...extensions, data]))
                    .then(() => history.push(routes.certificationsAndTraining.extension.paid))
                    .then(() => handleSuccessBase())
                    .catch(() => handleErrorBase())
                }
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }
}

export default compose(withRouter, connect(mapStore, mapDispatch))(Request);
